(function() {

  const HideLabelInterval = setInterval(() => {
  const all_dropdowns = document.querySelectorAll('.variant-wrapper--dropdown');
  all_dropdowns.forEach(dropdown => {
    if (dropdown) {
      const all_variant_input_wraps = dropdown.querySelectorAll('[data-handle]');
      
      all_variant_input_wraps.forEach(variant_dropdown => {
        if (variant_dropdown) {
          const data_handle = variant_dropdown.getAttribute('data-handle');
          const label_info = dropdown.querySelectorAll('.variant__label-info');

          label_info.forEach(info => {
            if (info && data_handle === "taille") {
              info.classList.remove('hide');

              clearInterval(HideLabelInterval);
            }
          });
        }
      });
    }
  });
}, 0);

  console.log("called custom js")
  if (document.querySelector(".add_cart_btn__hide")) {
      let optionsSetInterval = setInterval(function() {
          function _handleChange(e) {
              if (e.currentTarget.hasAttribute("previous-value")) {
                  if (e.currentTarget.getAttribute("previous-value") == "checked") {
                      if (document.querySelector("#AddToCart-calc").classList.contains("hide")) {
                          //console.log("yes")
                          document.querySelector(".product-single__form").querySelector("button[name='add']").style.display = "block";
                      }
                  } else {
                      clearInterval(optionsSetInterval)
                  }
              }
          }
          document.querySelectorAll("input[name='Couleur']").forEach((input) => {
              input.addEventListener("change", _handleChange.bind(this), true);
          })

      }, 1000)
  }
  const loadImagesWithAlt = selectedColor => {
      selectedColor = selectedColor.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(' ', '-');
      //     console.log("Normalized Selected Color", selectedColor);
      if (selectedColor == "") return;
      let optionName = selectedColor.includes("_") ? selectedColor.split("_")[0] : "colour_";
      let selectedAltText = `${optionName}${selectedColor}`;
      let imageArray = new Array(),
          thumbsArray = new Array();

      document.querySelector(".product-images-with-alt").querySelectorAll(".product-main-slide")
          .forEach((slide) => {
              let setName = slide.getAttribute("data-set-name") ? slide.getAttribute("data-set-name") : "";
              let groupName = slide.getAttribute("data-group") ? slide.getAttribute("data-group") : "";
              if (setName.length && groupName.length) {
                  if (slide.getAttribute("data-set-name") == optionName.replace("_", "") && slide.getAttribute("data-group").toLowerCase() == selectedAltText) {
                      imageArray.push(slide.cloneNode(true));
                  }
              }
              if (setName == "" && groupName == "") {
                  imageArray.push(slide.cloneNode(true));
              }
          });

      document.querySelector(".product__thumbs-with-alt").querySelectorAll(".product__thumb-item")
          .forEach((thumbSlide) => {
              let setName = thumbSlide.getAttribute("data-set-name") ? thumbSlide.getAttribute("data-set-name") : "";
              let groupName = thumbSlide.getAttribute("data-group") ? thumbSlide.getAttribute("data-group") : "";
              if (setName.length && groupName.length) {
                  if (thumbSlide.getAttribute("data-set-name") == optionName.replace("_", "") && thumbSlide.getAttribute("data-group").toLowerCase() == selectedAltText) {
                      thumbsArray.push(thumbSlide.cloneNode(true));
                  }
              }
              if (setName == "" && groupName == "") {
                  thumbsArray.push(thumbSlide.cloneNode(true));
              }
          });

      if (imageArray.length) {
          let slider = Flickity.data(document.querySelector('.product-slideshow'));
          if (slider) slider.destroy();
          document.querySelector('.product-slideshow').innerHTML = "";
          let count = 0;
          //imageArray.reverse();
          for (let image of imageArray) {
              if (count == 0) {
                  image.classList.remove("starting-slide", "secondary-slide", "is-selected");
                  image.classList.add("starting-slide");
              }
              image.setAttribute("data-index", count);
              document.querySelector(".product-slideshow").insertAdjacentHTML("beforeend", image.outerHTML);
              count++;
          }
          window.initCustomProductSlider();

          document.querySelector(".product__thumbs--scroller").querySelectorAll(".product__thumb-item").forEach(function(thumbInstance) {
              let thumbSetName = thumbInstance.getAttribute("data-set-name") ? thumbInstance.getAttribute("data-set-name") : "";
              let thumbGroupName = thumbInstance.getAttribute("data-group") ? thumbInstance.getAttribute("data-group").toLowerCase() : "";
              (thumbSetName == optionName.replace("_", "") && thumbGroupName == selectedAltText) ? thumbInstance.classList.remove("hide"): thumbInstance.classList.add("hide");
          });

          document.querySelector(".product__thumbs--scroller").innerHTML = "";
          let thumbCount = 0;
          //thumbsArray.reverse();
          for (let thumb of thumbsArray) {
              if (thumbCount == 0) {
                  thumb.querySelector(".product__thumb").classList.remove("is-active");
                  thumb.querySelector(".product__thumb").classList.add("starting-slide");
              }
              thumb.querySelector(".product__thumb").setAttribute("data-index", thumbCount);
              thumb.classList.remove("hide");
              document.querySelector('.product__thumbs--scroller').insertAdjacentHTML("beforeend", thumb.outerHTML);
              thumbCount++;
          }
          document.querySelector(".product__thumbs--scroller").querySelectorAll(".product__thumb-item:not(.hide)")[0].querySelector(".product__thumb").classList.add("is-active");
          window.initCustomImageZoom(document.querySelector(".product-section"));
      }
  }

  window.addEventListener("click", function(event) {
      if (!event.target.closest(".product__thumb")) return;
      event.preventDefault();
      document.querySelectorAll(".product__thumb").forEach(function(thumbInstance) {
          thumbInstance.classList.remove("is-active");
      });
      event.target.closest(".product__thumb").classList.add("is-active");
      let index = parseInt(event.target.closest(".product__thumb").getAttribute("data-index"));
      if (Flickity.data(document.querySelector('.product-slideshow'))) {
          Flickity.data(document.querySelector(".product-slideshow")).select(index);
      }
  });

  function boldOptionChangeEvent(event) {
      let isChecked = event.target.checked;
      let input = event.target;
      if (isChecked) {
          let selectedValue = (input.getAttribute("value")).toLowerCase().replace(" ", "-");
          loadImagesWithAlt(selectedValue);
      }
  }
  let optionsSetInterval = setInterval(function() {
    let boldOption = document.querySelectorAll(".gpo-swatches");
    if(boldOption.length){
       clearInterval(optionsSetInterval);
        boldOption.forEach(function(option) {
        if(option){
          option.querySelector("input").addEventListener("change", boldOptionChangeEvent.bind(this), true);
        }        
    });
    }
    
  }, 1000)

  /*-- Template Code --*/
  function parameterChanged(event) {
      document.querySelector("#AddToCart-calc").classList.remove("hide");
      document.querySelector(".add_cart_btn__hide").classList.remove("show_addtocart");
      if (document.querySelector(".product-single__form").querySelector("button[name='add'].gpo-clone-atc-button")) {
          document.querySelector(".product-single__form").querySelector("button[name='add'].gpo-clone-atc-button").style.display = "none";
      } else {
          document.querySelector(".product-single__form").querySelector("button[name='add']").style.display = "none";
      }

  }

  function _handleQtyChange(e) {
      let target = e.currentTarget;
      if (target.getAttribute("data-operator") == "minus") {
          let currentValue = parseInt(target.closest(".js-qty__wrapper_number").querySelector("input").value);
          let newValue = currentValue - 1;
          if (newValue > 0) {
              target.closest(".js-qty__wrapper_number").querySelector("input").value = newValue;
          } else {
              target.closest(".js-qty__wrapper_number").querySelector("input").value = 1;
          }

      }

      if (target.getAttribute("data-operator") == "plus") {
          let currentValue = parseInt(target.closest(".js-qty__wrapper_number").querySelector("input").value);
          let newValue = currentValue + 1;
          if (newValue > 0) {
              target.closest(".js-qty__wrapper_number").querySelector("input").value = newValue;
          } else {
              target.closest(".js-qty__wrapper_number").querySelector("input").value = 1;
          }

      }


  }

  let qtyManipulator = document.querySelectorAll(".js-number-of-pieces-manipulator");
  if (qtyManipulator.length) {
      qtyManipulator.forEach((manipulator) => {
          manipulator.addEventListener("click", _handleQtyChange.bind(this), true);
          manipulator.addEventListener("click", parameterChanged.bind(this), true);

      })
  }
  if (document.querySelector(".custom-fields") && document.querySelector(".custom-fields").getAttribute("data-product-template") == "product.custom-length") {
      document.querySelector("#customLength").addEventListener("keydown", function(event) {
          if (event.key == "Enter") {
              event.preventDefault();
              return;
          }
      }, );
  }
  if (document.querySelector(".custom-fields-velvet") && document.querySelector(".custom-fields-velvet").getAttribute("data-product-template") == "product.custom-velvet-curtain") {
      document.querySelector("#customLength").addEventListener("keydown", function(event) {
          if (event.key == "Enter") {
              event.preventDefault();
              return;
          }
      }, );
  }
  (function() {

      let productPriceElement = document.querySelector(`[data-product-price]`);
      if(document.querySelector(`[data-product-price]`)){
        let initialPrice = productPriceElement.querySelector(".money").innerHTML;
      }
      let $targetMeasurementField = document.querySelectorAll(".mesurement");
      let $userQty = document.querySelector("#user_quantity");
      let priceCalculatingButton = document.querySelector("#AddToCart-calc");
      let mearurementErrorMsg = document.querySelector(".m-error");
      let qtyErrorMsg = document.querySelector(".q-error");
      let compareAtPriceElement = document.querySelector("[data-compare-price]");
      let savePriceElement = document.querySelector("[data-save-price]");
    
      if(document.querySelector(".custom-fields")){
      if (document.querySelector(".custom-fields").getAttribute("data-product-template") == "product.custom-size-rectangular" || document.querySelector(".custom-fields").getAttribute("data-product-template") == "product.custom-size-oval") {
          $targetMeasurementField.forEach(function(measurementInput) {
              measurementInput.addEventListener("change", parameterChanged.bind(this), true);
          });
          $userQty.addEventListener("change", parameterChanged.bind(this), true);
      }
      if (document.querySelector(".custom-fields").getAttribute("data-product-template") == "product.custom-size-circular") {
          $targetMeasurementField.forEach(function(measurementInput) {
              measurementInput.addEventListener("keyup", parameterChanged.bind(this), false);
          });
          $userQty.addEventListener("keyup", parameterChanged.bind(this), false);
      }
      if (document.querySelector(".custom-fields").getAttribute("data-product-template") == "product.custom-length") {
          $targetMeasurementField.forEach(function(measurementInput) {
              measurementInput.addEventListener("input", parameterChanged.bind(this), true);
          });
          $userQty.addEventListener("change", parameterChanged.bind(this), true);
      }
        
      priceCalculatingButton.addEventListener("click", function() {
          if (document.querySelector(".custom-fields").getAttribute("data-product-template") == "product.custom-size-rectangular" || document.querySelector(".custom-fields").getAttribute("data-product-template") == "product.custom-size-oval") {
              let customWidth = Number(document.querySelector("#width").value);
              let customLength = Number(document.querySelector("#length").value);
             
              if (customLength < 1 ) {
                  qtyErrorMsg.classList.remove("hide");
                  return;
              }
              qtyErrorMsg.classList.add("hide");
              if (document.querySelector(".custom-fields").getAttribute("data-product-type") == "Rideaux sur mesure") {
                  if (customWidth < 100) {
                     document.querySelector(".m-error").classList.remove("hide");
                      //document.querySelector(".add_cart_btn__hide").classList.add("show_addtocart");
                      return;
                  }
              }

              let multiply = 1;
              let actual_quantity;
              let currentUserQty = Number($userQty.value);
              $targetMeasurementField.forEach((measurementElement) => {
                  multiply = multiply * Number(measurementElement.value);

              });
               console.log("multiply",multiply)
              if (currentUserQty > 0 && multiply > 0) {
                  mearurementErrorMsg.classList.add("hide");
                  qtyErrorMsg.classList.add("hide");
                  document.querySelector("#AddToCart-calc").classList.add("hide");
                  document.querySelector(".add_cart_btn__hide").classList.add("show_addtocart");
                  if (document.querySelector(".product-single__form").querySelector("button[name='add'].gpo-clone-atc-button")) {

                      document.querySelector(".product-single__form").querySelector("button[name='add'].gpo-clone-atc-button").style.display = "block";
                  } else {

                      document.querySelector(".product-single__form").querySelector("button[name='add']").style.display = "block";
                  }

                  actual_quantity = multiply * currentUserQty;
                  actual_quantity = Math.round(actual_quantity / 100);
                  if (actual_quantity < 1) {
                      document.querySelector(".product-single__form").querySelector("input[name='quantity']").value = 1;
                  } else {
                      document.querySelector("input[name='quantity']").value = actual_quantity;
                  }
                  update_price(actual_quantity);

              } else {
                  if (currentUserQty <= 0) {
                      if (qtyErrorMsg.classList.contains("hide")) {
                          qtyErrorMsg.classList.remove("hide");
                      }
                  } else {
                      qtyErrorMsg.classList.add("hide");
                  }
               
                  if (multiply <= 0) {
                      if (mearurementErrorMsg.classList.contains("hide")) {
                          mearurementErrorMsg.classList.remove("hide");
                      }
                  } else {
                      mearurementErrorMsg.classList.add("hide");
                  }
              }
          }
          if (document.querySelector(".custom-fields").getAttribute("data-product-template") == "product.custom-size-circular") {
             let customDiameter = Number(document.querySelector("#diameter").value); 
            if (customDiameter < 1 ) {
                  qtyErrorMsg.classList.remove("hide");
                  return;
              }
              qtyErrorMsg.classList.add("hide");
              let multiply = 1;
              let actual_quantity;
              let currentUserQty = Number($userQty.value);
              $targetMeasurementField.forEach((measurementElement) => {
                  multiply = multiply * Number(measurementElement.value);
              });


              if (currentUserQty > 0 && multiply > 0) {
                  mearurementErrorMsg.classList.add("hide");
                  qtyErrorMsg.classList.add("hide");
                  document.querySelector("#AddToCart-calc").classList.add("hide");
                  document.querySelector(".add_cart_btn__hide").classList.add("show_addtocart");
                  if (document.querySelector(".product-single__form").querySelector("button[name='add'].bold_clone")) {
                      document.querySelector(".product-single__form").querySelector("button[name='add'].bold_clone").style.display = "block";
                  } else {
                      document.querySelector(".product-single__form").querySelector("button[name='add']").style.display = "block";
                  }


                  actual_quantity = (multiply / 2) * (multiply / 2) * 3.14;
                  actual_quantity = Math.round(actual_quantity / 100);
                  actual_quantity = actual_quantity * currentUserQty;
                  if (actual_quantity < 1) {
                      document.querySelector(".product-single__form").querySelector("input[name='quantity']").value = 1;
                  } else {
                      document.querySelector("input[name='quantity']").value = actual_quantity;
                  }
                
                  update_price(actual_quantity);
              } else {
                  if (currentUserQty <= 0) {
                      if (qtyErrorMsg.classList.contains("hide")) {
                          qtyErrorMsg.classList.removeClass("hide");
                      }

                  } else {
                      qtyErrorMsg.classList.add("hide");
                  }

                  if (multiply <= 0) {
                      if (mearurementErrorMsg.classList.contains("hide")) {
                          mearurementErrorMsg.classList.remove("hide");
                      }
                  } else {
                      mearurementErrorMsg.classList.add("hide");
                  }
              }
          }
          if (document.querySelector(".custom-fields").getAttribute("data-product-template") == "product.custom-length") {
              let customWidth = 1;
              let customLength = Number(document.querySelector("#customLength").value);
              if (customLength < 100) {
                  qtyErrorMsg.classList.remove("hide");
                  return;
              }
              qtyErrorMsg.classList.add("hide");
              document.querySelector("#user_quantity").value = customLength * customWidth;
              document.querySelector(".product-single__meta").querySelector("input[name='quantity']").value = document.querySelector("#user_quantity").value * document.querySelector(`input[name='properties[${window.theme.strings.number_of_pieces}]']`).value;
              console.log("neeewww:" ,document.querySelector(".product-single__meta").querySelector("input[name='quantity']").value);
              let finalQuantity = Number(document.querySelector(".product-single__meta").querySelector(`input[name='properties[${window.theme.strings.number_of_pieces}]']`).value);
              document.querySelector("#AddToCart-calc").classList.add("hide");
              document.querySelector(".add_cart_btn__hide").classList.add("show_addtocart");
              if (document.querySelector(".product-single__meta").querySelector("button[name='add'].bold_clone")) {
                  document.querySelector(".product-single__meta").querySelector("button[name='add'].bold_clone").style.display = "block";
              } else {
                  document.querySelector(".product-single__meta").querySelector("button[name='add']").style.display = "block";
              }
              let finalPrice = Number(document.querySelector(".product-single__meta").querySelector("input[name='quantity']").value) * Number(document.querySelector("[data-product-price]").getAttribute("content"));
              updatePrice(finalPrice * 100);
          }
          
      }, true);
    }

    if(document.querySelector(".custom-fields-velvet")){
      productPriceElement.querySelector(".money").innerHTML = `${window.theme.strings.custom_velvet_product}`;
      productPriceElement.style.visibility = "visible";
      if (document.querySelector(".custom-fields-velvet").getAttribute("data-product-template") == "product.custom-velvet-curtain") {
          $targetMeasurementField.forEach(function(measurementInput) {
              measurementInput.addEventListener("input", parameterChanged.bind(this), true);
          });
          $userQty.addEventListener("change", parameterChanged.bind(this), true);
      }
        
      priceCalculatingButton.addEventListener("click", function() {

          if (document.querySelector(".custom-fields-velvet").getAttribute("data-product-template") == "product.custom-velvet-curtain") {
              let customWidth = 1;
              let customLength = Number(document.querySelector("#customLength").value);
              if (customLength < 100) {
                  qtyErrorMsg.classList.remove("hide");
                  return;
              }
              qtyErrorMsg.classList.add("hide");
              document.querySelector("#user_quantity").value = customLength * customWidth;
              document.querySelector(".product-single__meta").querySelector("input[name='quantity']").value = document.querySelector("#user_quantity").value * document.querySelector(`input[name='properties[${window.theme.strings.number_of_pieces}]']`).value;
              let finalQuantity = Number(document.querySelector(".product-single__meta").querySelector(`input[name='properties[${window.theme.strings.number_of_pieces}]']`).value);
              document.querySelector("#AddToCart-calc").classList.add("hide");
              document.querySelector(".add_cart_btn__hide").classList.add("show_addtocart");
              if (document.querySelector(".product-single__meta").querySelector("button[name='add'].bold_clone")) {
                  document.querySelector(".product-single__meta").querySelector("button[name='add'].bold_clone").style.display = "block";
              } else {
                  document.querySelector(".product-single__meta").querySelector("button[name='add']").style.display = "block";
              }
              let finalPrice = Number(document.querySelector(".product-single__meta").querySelector("input[name='quantity']").value) * Number(document.querySelector("[data-product-price]").getAttribute("content"));
              VelvetUpdatePrice(finalPrice * 100);
          }
          
      }, true);
    }

      function update_price(quantity) {
          if (document.querySelector(".custom-fields").getAttribute("data-product-template") == "product.custom-size-rectangular" || document.querySelector(".custom-fields").getAttribute("data-product-template") == "product.custom-size-circular" || document.querySelector(".custom-fields").getAttribute("data-product-template") == "product.custom-size-oval" || document.querySelector(".custom-fields-velvet").getAttribute("data-product-template") == "product.custom-velvet-curtain") {
              let updatedPrice = Number(productPriceElement.getAttribute('content')) * Number(quantity);
              document.querySelector("input[name='quantity']").value = Number(quantity);
              let originalVariantPrice = Number(productPriceElement.getAttribute('content'));
              if (quantity === 0 || quantity === "") {} else {
                  productPriceElement.querySelector(".money").innerHTML = theme.Currency.formatMoney(updatedPrice, theme.settings.moneyFormat)
              }
              document.querySelector(".prod-price-per-txt").innerHTML = ' (' + theme.Currency.formatMoney(originalVariantPrice * 100, theme.settings.moneyFormat) + ' per square meter)'
              //theme.currencySwitcher.init();
          }
          if (document.querySelector(".custom-fields").getAttribute("data-product-template") == "product.custom-size-circular" || document.querySelector(".custom-fields-velvet").getAttribute("data-product-template") == "product.custom-velvet-curtain") {
              let updatedPrice = Number(productPriceElement.getAttribute('content')) * Number(quantity);
              let originalVariantPrice = Number(productPriceElement.getAttribute('content'));
              if (quantity === 0 || quantity === "") {} else {
                  productPriceElement.querySelector(".money").innerHTML = theme.Currency.formatMoney(updatedPrice, theme.settings.moneyFormat)
              }
              document.querySelector(".prod-price-per-txt").innerHTML = '(' + theme.Currency.formatMoney(originalVariantPrice * 100, theme.settings.moneyFormat) + ' per square meter)'
              //theme.currencySwitcher.init();
          }
      }

      function updatePrice(finalPrice) {
          let originalVariantPrice = Number(productPriceElement.getAttribute('content')) * 100;
          productPriceElement.innerHTML = theme.Currency.formatMoney(finalPrice, theme.settings.moneyFormat);
          let spanForPerMeter = document.createElement("SPAN");
          spanForPerMeter.classList.add("prod-price-per-txt");
          spanForPerMeter.innerHTML = `   (${theme.Currency.formatMoney(originalVariantPrice * 100, theme.settings.moneyFormat)} per meter) `;
          productPriceElement.insertAdjacentElement("beforeend", spanForPerMeter);
          if(compareAtPriceElement){
            let compareAtPrice = Number(compareAtPriceElement.getAttribute("data-content"));
            if (compareAtPrice > 0) {
                let quantity = Number(document.querySelector(".product-single__meta").querySelector("input[name='quantity']").value);
                let perMeterQty = quantity / 100;
                compareAtPriceElement.innerHTML = theme.Currency.formatMoney((compareAtPrice * 100) * perMeterQty, theme.settings.moneyFormat)
                let spanForSavings = document.createElement("SPAN");
                spanForSavings.classList.add("prod-price-per-txt");
                let totalSavings = (compareAtPrice * perMeterQty) - (finalPrice / 100);
                spanForSavings.innerHTML = `${window.theme.strings.savePrice.replace("[saved_amount]", theme.Currency.formatMoney(totalSavings*100, theme.settings.moneyFormat))}`;
                savePriceElement.innerHTML = "";
                savePriceElement.insertAdjacentElement("beforeend", spanForSavings);
            }
          }
          
                  // productPriceElement.insertAdjacentElement("beforeend",span)
                  // document.querySelector(".prod-price-per-txt").innerHTML = '('+ theme.Currency.formatMoney(originalVariantPrice * 100, theme.settings.moneyFormat) +' per meter)';
      }
    
      function VelvetUpdatePrice(finalPrice) {
          let originalVariantPrice = Number(productPriceElement.getAttribute('content')) * 100;
          productPriceElement.innerHTML = theme.Currency.formatMoney(finalPrice, theme.settings.moneyFormat);
          if(compareAtPriceElement){
            let compareAtPrice = Number(compareAtPriceElement.getAttribute("data-content") * 100);
            if (compareAtPrice > 0) {
                let quantity = Number(document.querySelector(".product-single__meta").querySelector("input[name='quantity']").value);
                let perMeterQty = quantity / 100;
                compareAtPriceElement.innerHTML = theme.Currency.formatMoney((compareAtPrice * 100) * perMeterQty, theme.settings.moneyFormat)
                let spanForSavings = document.createElement("SPAN");
                spanForSavings.classList.add("prod-price-per-txt");
                let totalSavings = (compareAtPrice * perMeterQty) - (finalPrice / 100);
                spanForSavings.innerHTML = `${window.theme.strings.savePrice.replace("[saved_amount]", theme.Currency.formatMoney(totalSavings*100, theme.settings.moneyFormat))}`;
                savePriceElement.innerHTML = "";
                savePriceElement.insertAdjacentElement("beforeend", spanForSavings);
            }
          }
          
                  // productPriceElement.insertAdjacentElement("beforeend",span)
                  // document.querySelector(".prod-price-per-txt").innerHTML = '('+ theme.Currency.formatMoney(originalVariantPrice * 100, theme.settings.moneyFormat) +' per meter)';
      }
  })();

  const variantChange = document.querySelector('.variant-input-wrap select');
  variantChange.addEventListener('change',()=>{
    parameterChanged();
    let productPriceElement = document.querySelector(`[data-product-price]`);
      if(document.querySelector(`[data-product-price]`)){
        let initialPrice = productPriceElement.querySelector(".money").innerHTML;
      }
      let $targetMeasurementField = document.querySelectorAll(".mesurement");
      let $userQty = document.querySelector("#user_quantity");
      let priceCalculatingButton = document.querySelector("#AddToCart-calc");
      let mearurementErrorMsg = document.querySelector(".m-error");
      let qtyErrorMsg = document.querySelector(".q-error");
      let compareAtPriceElement = document.querySelector("[data-compare-price]");
      let savePriceElement = document.querySelector("[data-save-price]");
    if(document.querySelector(".custom-fields-velvet")){
      productPriceElement.querySelector(".money").innerHTML = `${window.theme.strings.custom_velvet_product}`;
      productPriceElement.style.visibility = "visible";
      if (document.querySelector(".custom-fields-velvet").getAttribute("data-product-template") == "product.custom-velvet-curtain") {
          $targetMeasurementField.forEach(function(measurementInput) {
              measurementInput.addEventListener("input", parameterChanged.bind(this), true);
          });
          $userQty.addEventListener("change", parameterChanged.bind(this), true);
      }
        
      priceCalculatingButton.addEventListener("click", function() {

          if (document.querySelector(".custom-fields-velvet").getAttribute("data-product-template") == "product.custom-velvet-curtain") {
              let customWidth = 1;
              let customLength = Number(document.querySelector("#customLength").value);
              if (customLength < 100) {
                  qtyErrorMsg.classList.remove("hide");
                  return;
              }
              qtyErrorMsg.classList.add("hide");
              document.querySelector("#user_quantity").value = customLength * customWidth;
              document.querySelector(".product-single__meta").querySelector("input[name='quantity']").value = document.querySelector("#user_quantity").value * document.querySelector(`input[name='properties[${window.theme.strings.number_of_pieces}]']`).value;
              let finalQuantity = Number(document.querySelector(".product-single__meta").querySelector(`input[name='properties[${window.theme.strings.number_of_pieces}]']`).value);
              document.querySelector("#AddToCart-calc").classList.add("hide");
              document.querySelector(".add_cart_btn__hide").classList.add("show_addtocart");
              if (document.querySelector(".product-single__meta").querySelector("button[name='add'].bold_clone")) {
                  document.querySelector(".product-single__meta").querySelector("button[name='add'].bold_clone").style.display = "block";
              } else {
                  document.querySelector(".product-single__meta").querySelector("button[name='add']").style.display = "block";
              }
              let finalPrice = Number(document.querySelector(".product-single__meta").querySelector("input[name='quantity']").value) * Number(document.querySelector("[data-product-price]").getAttribute("content"));
              VelvetUpdatePrice(finalPrice);
          }
          
      }, true);

      function VelvetUpdatePrice(finalPrice) {
          let originalVariantPrice = Number(productPriceElement.getAttribute('content')) * 100;
          console.log(originalVariantPrice);
          productPriceElement.innerHTML = theme.Currency.formatMoney(finalPrice, theme.settings.moneyFormat);
          if(compareAtPriceElement){
            let compareAtPrice = Number(compareAtPriceElement.getAttribute("data-content"));
            if (compareAtPrice > 0) {
                let quantity = Number(document.querySelector(".product-single__meta").querySelector("input[name='quantity']").value);
                let perMeterQty = quantity / 100;
                compareAtPriceElement.innerHTML = theme.Currency.formatMoney((compareAtPrice * 100) * perMeterQty, theme.settings.moneyFormat)
                let spanForSavings = document.createElement("SPAN");
                spanForSavings.classList.add("prod-price-per-txt");
                let totalSavings = (compareAtPrice * perMeterQty) - (finalPrice / 100);
                spanForSavings.innerHTML = `${window.theme.strings.savePrice.replace("[saved_amount]", theme.Currency.formatMoney(totalSavings*100, theme.settings.moneyFormat))}`;
                savePriceElement.innerHTML = "";
                savePriceElement.insertAdjacentElement("beforeend", spanForSavings);
            }
          }
          
                  // productPriceElement.insertAdjacentElement("beforeend",span)
                  // document.querySelector(".prod-price-per-txt").innerHTML = '('+ theme.Currency.formatMoney(originalVariantPrice * 100, theme.settings.moneyFormat) +' per meter)';
      }
    }
  })
})();